import { useAPI } from "kw/api/useAPI";
import * as React from "react";

export const useCaptureContext = () => {
  const { query, loading } = useAPI();
  const [captureContext, setCaptureContext] = React.useState("");
  const getCaptureContext = () =>
    query(
      {
        cybersourceGenerateContext: {
          context: true,
        },
      },
      (response: { cybersourceGenerateContext: { context: string } }) => {
        const captureContext = response.cybersourceGenerateContext.context;
        setCaptureContext(captureContext);
      }
    );
  React.useEffect(() => {
    /*  Capture context expires after 15 minutes.
    Generate capture context on first render and then refresh it every 13 minutes.
    */
    if (!captureContext) {
      getCaptureContext();
    } else {
      setTimeout(() => {
        getCaptureContext();
      }, 780000);
    }
  }, [captureContext]);
  return {
    captureContext,
    getCaptureContext,
    loading,
  };
};
